import { Injectable } from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";


import {DynamicConfigModel} from "../model/dynamic-config-model";

@Injectable({
  providedIn: 'root'
})
export class DynamicControlService {

  constructor() { }

  toFormGroup(fieldConfigs: Array<DynamicConfigModel> ) {
    let group: any = {};

    fieldConfigs.forEach(config => {
      group[config.labelName] = config.required ? new FormControl(config.value || '', Validators.required)
          : new FormControl(config.value || '');
    });
    return new FormGroup(group);
  }
}
